export default {
  title: {
    purchaseOrder: 'ใบสั่งซื้อ  (PR)',
    importCertificate: 'ใบนำเข้า',
    productList: 'รายการสินค้า',
    purchaseResForm: 'ใบสั่งซื้อสินค้า (Purchase Reqisition)',
    importResForm: 'ใบสั่งซื้อสินค้า (Import Request Form)'
  },
  placeholder: {
    searchPR: 'ค้นหารหัสใบสั่งซื้อ  (PR)',
    searchIC: 'ค้นหารหัสใบนำเข้า',
    searchIdName: 'ค้นหา รหัสสินค้า ชื่อสินค้า',
    selectAll: 'เลือกทั้งหมด',
    selectCreateDate: 'เลือกวันที่สร้าง',
    enterSaler: 'กรอกผู้จัดจำหน่าย',
    enterDealer: 'กรอกผู้แทนจำหน่าย',
    plzEnterQty: 'โปรดกรอกจำนวนนำเข้า'
  },
  label: {
    id: 'รหัส',
    product: 'สินค้า',
    ingredient: 'ส่วนผสม',
    createDate: 'วันที่สร้าง',
    orderDate: 'วันสั่งซื้อ',
    drugFormula: 'สูตรยา',
    saler: 'ผู้จัดจำหน่าย',
    dealer: 'ตัวแทนจำหน่าย',
    orderer: 'ผู้สั่งซื้อ',
    prescriber: 'ผู้สั่งยา',
    resReviewer: 'ผู้ตรวจสอบคำขอ',
    approver: 'ผู้อนุมัติ',
    tax: 'ใบกำกับภาษี',
    haveTax: 'มีใบกำกับภาษี',
    buyPrice: 'ราคาซื้อ',
    qtyImports: 'จำนวนนำเข้า',
    outstandImports: 'จำนวนค้างนำเข้า',
    productType: 'ชนิดสินค้า',
    licenseNo: 'เลขที่ใบอนุญาต',
    PRNo: 'เลขที่/PR No.'
  },
  header: {
    PRId: 'รหัสใบสั่งซื้อ',
    ICId: 'รหัสใบนำเข้า',
    idNameIngredient: 'รหัส-ชื่อส่วนผสม',
    idNameProduct: 'รหัส-ชื่อสินค้า',
    date: 'วันที่',
    createDate: 'วันที่สร้าง',
    createBy: 'ผู้สร้าง',
    recipient: 'ผู้รับ',
    type: 'ประเภท',
    status: 'สถานะ',
    tax: 'ใบกำกับภาษี',
    stock: 'สต็อก',
    unit: 'หน่วย',
    list: 'รายการ',
    pricePerUnit: 'ราคาสั่งซื้อต่อหน่วย',
    qty: 'จำนวนสั่งซื้อ'
  },
  state: {
    all: 'ทั้งหมด',
    wait: 'รอรับ',
    received: 'รับแล้ว',
    cancel: 'ยกเลิก'
  },
  toolTip: {
    seePR: 'ดูข้อมูลใบสั่งซื้อ',
    seeIC: 'ดูข้อมูลใบนำเข้า',
    edit: 'แก้ไขข้อมูล',
    editPR: 'แก้ไขข้อมูลใบสั่งซื้อ',
    editIC: 'แก้ไขใบนำเข้า',
    delete: 'ลบข้อมูล',
    createIC: 'สร้างใบนำเข้า',
    createPR: 'สร้างใบสั่งซื้อ',
    cancelPR: 'ยกเลิกใบสั่งซื้อ'
  },
  alert: {
    PRcreate: 'สร้างใบสั่งซื้อสำเร็จ',
    PRedited: 'แก้ไขใบสั่งซื้อสำเร็จ',
    deleted: 'ลบสินค้าสำเร็จ',
    PRdeleted: 'ลบใบสั่งซื้อสำเร็จ',
    ICdeleted: 'ลบใบนำเข้าสำเร็จ',
    plzEnter: 'โปรดเพิ่มรายการก่อนที่จะสร้าง ใบสั่งซื้อ',
    plzAddPr: 'โปรดเพิ่มรายการสั่งซื้อก่อนที่จะสร้าง ใบนำเข้า !'
  },
  modal: {
    titleDelete: 'ยืนยันการลบใบสั่งซื้อ',
    subTitleDelete: 'คุณกำลังลบใบสั่งซื้อ ต้องการดำเนินการต่อหรือไม่ ?'
  }
}
